export const PROMPT_CATEGORIES = ['Forecasts', 'Drivers & risks', 'Report summaries', 'Client-ready'] as const;
export type PromptCategory = (typeof PROMPT_CATEGORIES)[number];

export type Prompt = { category: PromptCategory; text: string };

const in_ = (category: PromptCategory, texts: string[]): Prompt[] => texts.map((text) => ({ category, text }));

/** Questions known to answer well. Forecasts, drivers and report summaries come from the accuracy test
 * (backend/eval/cases.py), so each one is checked on every run; the client-ready ones shape those answers for a client. */
export const PROMPTS: readonly Prompt[] = [
  ...in_('Forecasts', [
    "What is OCBC's USD/SGD forecast?",
    "What is OCBC's EUR/USD forecast?",
    'USD/JPY forecast',
    'Where does OCBC see USD/CNH heading?',
    'What is the AUD/USD forecast?',
    "What is OCBC's forecast for the ringgit?",
    "What is OCBC's gold forecast?",
    'Brent oil price forecast',
    "What is OCBC's forecast for the Fed funds rate?",
    'SORA forecast',
    "What is OCBC's 2026 GDP growth forecast for Singapore?",
    "What is OCBC's 2026 GDP forecast for the euro area?",
    "What is OCBC's 2026 growth forecast for Malaysia?",
    'USD/SGD technical levels',
    'Where are EUR/USD support and resistance?',
    'What are the support levels for USD/JPY?',
  ]),
  ...in_('Drivers & risks', [
    'What is driving the USD/SGD view?',
    'What is driving the gold view?',
    'Why does OCBC expect the yen to stay weak?',
    'Why did OCBC lower its USD/SGD forecast?',
    'What does OCBC expect from MAS at the next meeting?',
    'Will the BoJ hike rates again?',
    'What is the ECB likely to do next?',
    "What is OCBC's view on UST yields?",
    "What is OCBC's outlook for Asian credit?",
  ]),
  ...in_('Report summaries', [
    'What did the August Research Monitor say about China?',
    "What is OCBC's view on SGD?",
    "What is OCBC's view on MYR?",
    "What is OCBC's view on China?",
    'What is the house view on the US economy?',
  ]),
  ...in_('Client-ready', [
    "Compare OCBC's views on SGD and MYR",
    "Summarise OCBC's USD/SGD view in three bullets for a client",
  ]),
];

export const promptsIn = (category: PromptCategory) => PROMPTS.filter((p) => p.category === category);

/** Prompts whose text contains every word of the search, in the chosen category or all of them. */
export function findPrompts(search: string, category: PromptCategory | null): Prompt[] {
  const words = search.toLowerCase().split(/\s+/).filter(Boolean);
  return PROMPTS.filter(
    (p) => (category === null || p.category === category) && words.every((w) => p.text.toLowerCase().includes(w)),
  );
}
